import { useEffect } from 'react';
import { PANEL_URL } from '../lib/api';

/**
 * Przekierowanie na stronę logowania panelu (panel.turnivo.pl/login).
 * Używane gdy użytkownik wejdzie na turnivo.pl/login – od razu idzie do panelu.
 */
export default function RedirectToPanelLogin() {
  useEffect(() => {
    const url = `${PANEL_URL}/login`;
    window.location.href = url;
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <p className="text-slate-600">Przekierowuję do panelu…</p>
    </div>
  );
}
